import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["dictionary", "invalid", "isDisabledStrength", "isDesktop", "onFocus", "onBlur", "tooltip", "value"];
import React, { useCallback, useRef, useState } from 'react';
import { bool, func, node, shape, string } from 'prop-types';
import classNames from 'classnames/bind';
import { OnBoardingTooltip, Textfield } from '@s7/ui-kit';
import PasswordStrengthTip from './components/PasswordStrengthTip';
import styles from './PasswordStrength.css';
var cx = classNames.bind(styles);

var PasswordStrength = function PasswordStrength(_ref) {
  var dictionary = _ref.dictionary,
      invalid = _ref.invalid,
      isDisabledStrength = _ref.isDisabledStrength,
      isDesktop = _ref.isDesktop,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      tooltip = _ref.tooltip,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded);

  var container = useRef(document.body);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      touched = _useState2[0],
      setTouched = _useState2[1];

  var handleFocus = useCallback(function (event) {
    if (onFocus) {
      onFocus(event);
    }
  }, [onFocus]);
  var handleBlur = useCallback(function (event) {
    setTouched(true);

    if (onBlur) {
      onBlur(event);
    }
  }, [onBlur]);

  var getContainer = function getContainer() {
    if (container.current) {
      return container.current;
    }

    return document.body;
  };

  var field = isDesktop ? /*#__PURE__*/React.createElement(OnBoardingTooltip, {
    content: /*#__PURE__*/React.createElement(PasswordStrengthTip, {
      dictionary: dictionary,
      variant: "default"
    }),
    contentTextProps: {
      as: 'span'
    },
    direction: "right",
    disableHover: true,
    getContainer: getContainer,
    id: "tooltip-test-id",
    opened: !isDisabledStrength && tooltip
  }, /*#__PURE__*/React.createElement(Textfield, _extends({
    invalid: touched && (invalid || !!tooltip),
    onBlur: handleBlur,
    onFocus: handleFocus,
    tooltip: touched && tooltip,
    type: "password",
    value: value
  }, rest))) : /*#__PURE__*/React.createElement(Textfield, _extends({
    invalid: touched && (invalid || !!tooltip),
    onBlur: handleBlur,
    onFocus: handleFocus,
    tooltip: /*#__PURE__*/React.createElement(PasswordStrengthTip, {
      dictionary: dictionary,
      error: touched && (invalid || !!tooltip),
      variant: "dimmed"
    }),
    type: "password",
    value: value
  }, rest));
  return /*#__PURE__*/React.createElement("div", {
    className: cx('root'),
    ref: container
  }, field);
};

PasswordStrength.propTypes = {
  dictionary: shape({
    t: func.isRequired
  }).isRequired,
  invalid: bool,
  isDisabledStrength: bool,
  isDesktop: bool,
  onBlur: func,
  onFocus: func,
  tooltip: node,
  value: string
};
export default PasswordStrength;